import resizeCards from './cards'
import LazyLoad from "vanilla-lazyload";

// Reveal more product list
//Hide cards on load

export default function revealCards() {
  var myLazyLoad = new LazyLoad({
    elements_selector: ".lazy"
  });
  var cardItemsHidden = document.querySelectorAll(".product-listing .card--item:nth-child(1n+13)");
  var cardItemsAll = document.querySelectorAll(".grid .card--item");
  var revealMore = document.querySelector(".reveal-more");
  if (revealMore) {
    revealMore.style.display = "none";


    if (cardItemsHidden.length != 0) {
      revealMore.style.display = "flex";
      for (let index = 0; index < cardItemsHidden.length; index++) {
        const element = cardItemsHidden[index];
        element.style.display = "none";
      }

      if (revealMore) {
        revealMore.addEventListener("click", function () {
          for (var i = 0; i < cardItemsAll.length; i++) {
            const element = cardItemsAll[i];
            element.style.display = "flex";

          }
          this.style.display = "none";
          resizeCards(cardItemsAll);
          var myLazyLoad = new LazyLoad({
            elements_selector: ".lazy"
          });
        })
      }
    }
  }
}

revealCards()


// WEBPACK FOOTER //
// ./scripts/components/revealMore.js